import type { FUSportsSocials } from "fansunited-data-layer";

export type SocialPlatform = keyof FUSportsSocials;

const PLATFORM_PREFIXES: Record<Exclude<SocialPlatform, "website">, string> = {
    x: "https://x.com/",
    facebook: "https://www.facebook.com/",
    instagram: "https://www.instagram.com/",
    wikipedia: "https://en.wikipedia.org/wiki/",
    youtube: "https://www.youtube.com/@",
    tiktok: "https://www.tiktok.com/@",
};

export function buildSocialUrl(platform: SocialPlatform, value: string | undefined): string | undefined {
    if (!value) return undefined;
    const trimmed = value.trim();
    if (!trimmed) return undefined;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (platform === "website") return `https://${trimmed.replace(/^\/+/, "")}`;
    const handle = trimmed.replace(/^@/, "");
    return `${PLATFORM_PREFIXES[platform]}${handle}`;
}

export function resolveSocials(socials: FUSportsSocials | undefined): FUSportsSocials | undefined {
    if (!socials) return undefined;
    const resolved: FUSportsSocials = {
        website: buildSocialUrl("website", socials.website),
        x: buildSocialUrl("x", socials.x),
        facebook: buildSocialUrl("facebook", socials.facebook),
        instagram: buildSocialUrl("instagram", socials.instagram),
        wikipedia: buildSocialUrl("wikipedia", socials.wikipedia),
        youtube: buildSocialUrl("youtube", socials.youtube),
        tiktok: buildSocialUrl("tiktok", socials.tiktok),
    };
    return Object.values(resolved).some(Boolean) ? resolved : undefined;
}
